import {
  useEffect,
  useRef,
  MutableRefObject
} from 'react';

import { useGoogleInfoWindow } from './useGoogleInfoWindow';
import { useHereInfoWindow } from './useHereInfoWindow';

import {
  isGoogleMap,
  isHereMap
} from 'common/constants';

import {
  MapInfoWindowProps,
  RootElementRef
} from '../ui/MapInfoWindow/MapInfoWindow';

// import { MAP_INFO_WINDOW_ID } from '../constants';

interface Props extends Pick<
  MapInfoWindowProps,
  'coordinates' | 'markers' | 'map' | 'showCloseIcon'
> {
  rootRef: MutableRefObject<RootElementRef>;
}

interface Handlers {
  onClose: MapInfoWindowProps['onClose']
}

export const useUpdateInfoWindow = (
  {
    map,
    markers,
    coordinates,
    rootRef,
    showCloseIcon,
  }: Props,
  {
    onClose
  }: Handlers
) => {
  const infoWindowRef = useRef<any | null>(null);
  const googleInfoWindow = useGoogleInfoWindow(map);
  const hereInfoWindow = useHereInfoWindow(map, showCloseIcon, onClose);

  // const hidePathDescription = useCallback(() => {
  //   if (infoWindowRef.current) {
  //     infoWindowRef.current.hide();
  //     infoWindowRef.current = null;
  //   }
  // }, [infoWindowRef]);

  useEffect(() => {
    if (infoWindowRef.current) {
      infoWindowRef.current.hide();
    }

    if (coordinates && coordinates.length && map && rootRef.current) {
      if (isGoogleMap(map.name)) {
        infoWindowRef.current = googleInfoWindow(coordinates, rootRef.current);
      }
      
      if (isHereMap(map.name)) {
        infoWindowRef.current = hereInfoWindow(coordinates, rootRef.current);
      }
    }
    
  // eslint-disable-next-line
  }, [
    coordinates,
    map,
    infoWindowRef,
    googleInfoWindow,
    hereInfoWindow,
    rootRef,
    showCloseIcon
  ]);

  useEffect(() => () => {
    if (infoWindowRef.current) {
      infoWindowRef.current.hide();
    }
  }, []);

  // useEffect(() => {
  //   const clickHandler = ({ object, ...otherProps }: any) => {
  //     if (!object || (object && object.cluster)) {
  //       hidePathDescription();

  //       if (onClose) {
  //         onClose();
  //       }
  //     }
  //   }

  //   if (markers) {
  //     markers.addClickHandler(clickHandler)
  //   }
    

  //   return () => {
  //     if (markers) {
  //       markers.deleteClickHandler(clickHandler);
  //     }
  //   }
  //   // eslint-disable-next-line
  // }, []);

  // useEffect(() => {
  //   const handlerDocumentClick = (event: MouseEvent) => {
  //     let targetElement = event.target;
  //     const popupElement = document.getElementById(MAP_INFO_WINDOW_ID);
  
  //     do {
  //       if (targetElement === popupElement) {
  //         return;
  //       }
  
  //       // @ts-ignore
  //       targetElement = (targetElement || {}).parentNode;
  //     } while (targetElement);
    
  //     hidePathDescription();
  //     if(onClose) onClose();
  //   }

  //   // @ts-ignore
  //   window.document.addEventListener('click', handlerDocumentClick);

  //   return () => {
  //     // @ts-ignore
  //     window.document.removeEventListener('click', handlerDocumentClick);
  //   };
  //   // eslint-disable-next-line
  // }, []);
};
